const SocialNetworksCarousel = () => {
  return (
    <div className="card">
      <iframe
        src="https://www.linkedin.com/embed/feed/update/urn:li:share:7457342130072621057?collapsed=1"
        height="602"
        width="504"
        allowFullScreen=""
        title="Embedded post"
        style={{ maxWidth: "100%", border: "none" }}
      ></iframe>
    </div>
  );
};

export default SocialNetworksCarousel;
